import {Stack, Typography} from "@mui/material";
import * as React from "react";
import ProfileUrlField from "./ProfileUrlField";
import {useIsMobileHook} from "../../../utils";

const UserProfilePanel = () => {
    const isMobile = useIsMobileHook()
    return <Stack sx={{backgroundColor: 'rgba(0, 0, 0, 0.2)', p: {xs: '5px 10px', md: '5px 15px'}, m: {xs: 0, md: '5px'}, borderRadius: '10px'}}>
        <Typography sx={{color: '#ccc', fontSize: {xs: '0.7rem', md: '0.8rem'}, textAlign: 'center', lineHeight: {xs: '0.8rem', md: 'auto'}}}>
            Click any text to edit your profile. All info entered here will be public to everyone.<br/>{isMobile ? <br/> : ''}
            Fields with (optional) will not display to others. Click the trash icon to reset a field to default (not
            displayed)
        </Typography>
        <ProfileUrlField/>
    </Stack>
}

export default UserProfilePanel